import { render, staticRenderFns } from "./crew.vue?vue&type=template&id=64f69f4e"
import script from "./crew.vue?vue&type=script&lang=js"
export * from "./crew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports